import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/shared/auth/authStore";
import { isAgentOnly } from "./useSoftphoneRuntime";

/** Página inicial: agente puro (só ROLE_USER) cai direto em `/atendimento`. */
export function AgentIndexGate({ children }: { children: ReactNode }) {
  const roles = useAuthStore((s) => s.roles);
  if (isAgentOnly(roles)) return <Navigate to="/atendimento" replace />;
  return children;
}
